//@ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchPopupStatusRequest,
  fetchPopupStatusSuccess,
  fetchPopupStatusFailure,
  updatePopupStatusRequest,
  updatePopupStatusSuccess,
  updatePopupStatusFailure,
  fetchAccountStatusRequest,
  fetchAccountStatusSuccess,
  fetchAccountStatusFailure,
} from '../reducer/popupSlice';
import { getPopupStatus, updatePopupStatus, getAccountStatus } from '../api'; // Assuming API paths are correct

interface PopupRequestAction {
  type: typeof fetchPopupStatusRequest.type;
  payload: { accountId: string; customerId: string };
}

interface PopupUpdateAction {
  type: typeof updatePopupStatusRequest.type;
  payload: { accountId: string; customerId: string; status: string };
}

// Fetch card lock status saga
export function* fetchPopupStatusSaga(
  action: PopupRequestAction
): Generator<any, void, unknown> {
  try {
    const { accountId, customerId } = action.payload;
    const response: any = yield call(
      getPopupStatus,
      'fetch_popup',
      accountId,
      customerId
    );
    // If the API response has the lock status under `data`, modify the structure accordingly.
    if (response) {
      console.log('response', response);
      yield put(fetchPopupStatusSuccess(response)); // Assuming API response has a `status` field
    } else {
      yield put(
        fetchPopupStatusFailure(
          error.message || 'Failed to fetch card lock status.'
        )
      );
    }
  } catch (error: any) {
    yield put(
      fetchPopupStatusFailure(
        error.message || 'Failed to fetch card lock status.'
      )
    );
  }
}

// Update card lock status saga
export function* updatePopupStatusSaga(
  action: PopupUpdateAction
): Generator<any, void, unknown> {
  try {
    const { accountId, customerId, status } = action.payload;

    // Call API to update the card lock status
    yield call(
      updatePopupStatus,
      'update_popup',
      accountId,
      customerId,
      status
    );

    // After successful API call, dispatch the success action with the new status
    yield put(updatePopupStatusSuccess(status)); // Pass the new status ("LOCK" or "UNLOCK")

    // Optionally refetch the card lock status to refresh the UI
    yield put(fetchPopupStatusRequest({ accountId, customerId }));
  } catch (error: any) {
    yield put(
      updatePopupStatusFailure(
        error.message || 'Failed to update card lock status.'
      )
    );
  }
}

// Fetch card lock status saga
export function* fetchAccountStatusSaga(
  action: PopupRequestAction
): Generator<any, void, unknown> {
  try {
    const { accountId, customerId } = action.payload;
    const response: any = yield call(
      getAccountStatus,
      'account_status',
      accountId,
      customerId,
      isRefresh
    );
    // If the API response has the lock status under `data`, modify the structure accordingly.
    if (response) {
      yield put(fetchAccountStatusSuccess(response)); // Assuming API response has a `status` field
    } else {
      yield put(
        fetchAccountStatusFailure(
          error.message || 'Failed to fetch card lock status.'
        )
      );
    }
  } catch (error: any) {
    yield put(
      fetchAccountStatusFailure(
        error.message || 'Failed to fetch card lock status.'
      )
    );
  }
}

// Watch sagas
export function* watchPopupStatusSagas(): Generator<any, void, unknown> {
  yield takeLatest(fetchPopupStatusRequest.type, fetchPopupStatusSaga);
  yield takeLatest(updatePopupStatusRequest.type, updatePopupStatusSaga);
  yield takeLatest(fetchAccountStatusRequest.type, fetchAccountStatusSaga);
}
